import { servicesApi } from '@/services/api/deprecated';

export const getUserRoles = async (accountId: number, userId: number) => {
  const { data } = await servicesApi.get(`/accounts/${accountId}/users/${userId}/roles`);
  return data;
};
